import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { DrillDownInfo } from '../../models/drilldown-info';
import { ElearningInfo } from '../../models/elearning-info';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavLinkButton, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap/nav';
import { TranslatePipe } from '@ngx-translate/core';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faHandPointer, faSearchPlus, faTv } from '@fortawesome/free-solid-svg-icons';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'chart-info',
    styleUrls: ['./chart-info.scss'],
    templateUrl: 'chart-info.html',
    host: { 'cid': 'ChartInfo' },
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavLinkButton, NgbNavOutlet, TranslatePipe, FaIconComponent]
})
export class ChartInfoComponent implements OnInit {
    @Input() zoomScrollIsRelevant: boolean;
    @Input() drillDownInfo: DrillDownInfo;
    @Input() elearningInfo: ElearningInfo;
    @Output() drillUp = new EventEmitter();

    faSearchPlus = faSearchPlus;
    faHandPointer = faHandPointer;
    faTv = faTv;

    public activeId = 0;
    private hiddenTabId = 0;

    constructor(
        public location: Location,
        public sanitizer: DomSanitizer
    ) { }

    ngOnInit() {
        this.activeId = this.drillDownInfo.isDrillDowned ? 2 : this.hiddenTabId;
    }

    public onTabClick(clickedTabId: number): void {
        //Om klick på samma tab som visas => göm innehållet & visa fliken med tomt innehåll
        this.activeId = this.activeId == clickedTabId ? this.hiddenTabId : clickedTabId;
    }

    public getIframeSrc: SafeHtml = function (id) {
        return this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/'+id);
    }

}
